import 'regenerator-runtime/runtime';
import { processResponse, getFirstResponseActionNamed } from '@alme/ui-web/ref/lib-response-handler'; 
import { settings } from '@alme/ui-web/settings/settings-util';
import { checkUntilSatisfiedOrExhausted } from '@alme/ui-web/util/promise';
import { sendRequest } from '@alme/ui-web/ref/lib-alme-request';

export default class BookingFlow {

    constructor(passedSettings) {
        this._settings = passedSettings || settings;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return (state) => { return state; };
   }

   process(message){
        return processResponse(message, {
            processArray: this.processArray.bind(this),
            processSingle: this.processResponse.bind(this),
            responseActionName: this._settings.responseActionConstants.bookingFlowResponseActionName,
        });
    }

    processArray(messages) {
        const lastMessage = this.getLastHistoryMessage(messages);
        const actions = getFirstResponseActionNamed(
            lastMessage.response, 
            this._settings.responseActionConstants.bookingFlowResponseActionName);
        if (!actions) {
            return messages;
        }

        function checkForElement() {
            return document.querySelector(actions.Success);
        }
        this.evaluateForAppevent(checkForElement, "Success", "Timeout");
        return messages;
    }

    processResponse(response) {
        const actions = getFirstResponseActionNamed(
            response, 
            this._settings.responseActionConstants.bookingFlowResponseActionName);

        function checkForElement(){
            const errorElement = document.querySelector(actions.Error);
            const result = errorElement && errorElement.innerText && errorElement.innerText.trim() !== "";
            return result;
        }
        this.evaluateForAppevent(checkForElement, "Error");
        return response;
    }

    getLastHistoryMessage(history) {
        const historyLength = history.response.length,
            response = history.response[historyLength - 1];

        return {
            messageType: 'HistoryItem',
            response,
        };
    }

    async evaluateForAppevent(doesExist, success, fail) {
        const result = await checkUntilSatisfiedOrExhausted(doesExist, 200, 50);
        if(result){
            this.sendAppevent(success);
        }
        else if(fail){
            this.sendAppevent(fail);
        }
    }

    sendAppevent(value) {
        const input =
        {
            messageType: this._settings.messageConstants.appeventRequest,
            eventName: this._settings.appeventConstants.bookTicketsResultEventName,
            origin: this._settings.originConstants.external,
            parameters: {
                BookTicketsResult: value,
            },
        };
       sendRequest(input);
    } 
}


// WEBPACK FOOTER //
// ./components/response-handlers/booking-flow/booking-flow.js